import { PRODUCT } from '@/config/product';
import { cn } from '@/lib/utils';

interface BrandLogoProps {
  className?: string;
  variant?: 'default' | 'inverted';
  withText?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

/**
 * Marca do produto: escudo com um "traçado" estilizado (uma linha quebrada
 * sugerindo rota/movimento) em verde sobre fundo azul-marinho, com pontos
 * laranja nas extremidades. Combina com o favicon.
 */
export function BrandLogo({
  className,
  variant = 'default',
  withText = true,
  size = 'md',
}: BrandLogoProps) {
  const iconSize = size === 'sm' ? 28 : size === 'lg' ? 40 : 32;
  const textSize =
    size === 'sm' ? 'text-base' : size === 'lg' ? 'text-2xl' : 'text-lg';

  const bg = variant === 'inverted' ? '#FFFFFF' : '#0F2540';
  const stroke = variant === 'inverted' ? '#0F2540' : '#10B981';
  const dot = '#F59E0B';
  const textColor = variant === 'inverted' ? 'text-white' : 'text-foreground';

  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 32 32"
        fill="none"
        aria-hidden="true"
      >
        <rect width="32" height="32" rx="7" fill={bg} />
        <path
          d="M7 21.5L11.5 12L16 18.5L20.5 10L25 21.5"
          stroke={stroke}
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="8" cy="24.5" r="1.5" fill={dot} />
        <circle cx="24" cy="24.5" r="1.5" fill={dot} />
      </svg>
      {withText && (
        <span
          className={cn(
            'font-semibold tracking-tight leading-none',
            textSize,
            textColor,
          )}
        >
          {PRODUCT.name}
        </span>
      )}
    </div>
  );
}
